import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  Typography
} from "@mui/material";
import { mockParameters } from "../DataVisualization/MockData";

const NestedDropdown = ({ name, selectedParams, setSelectedParams, maxSelections = 3, parameters = {} }) => {
  const allOptions = Object.entries(parameters).flatMap(([group, items]) =>
    items.map((item) => ({
      ...item,
      group
    }))
  );

  const selectedKeys = selectedParams.map((p) => p.key);

  const handleToggle = (clickedKey) => {
    const isAlreadySelected = selectedKeys.includes(clickedKey);

    let updated;
    if (isAlreadySelected) {
      // Remove it
      updated = selectedParams.filter((p) => p.key !== clickedKey);
    } else {
      if (selectedParams.length >= maxSelections) return;
      const option = allOptions.find((opt) => opt.key === clickedKey);
      updated = [...selectedParams, { key: option.key, name: option.label }];
    }

    setSelectedParams(updated);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', position: 'relative', marginBottom: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', position: 'relative' }}>
        <InputLabel
          id={`${name}-label`}
          sx={{
            color: '#000',
            fontWeight: '800',
            fontFamily: 'Red Hat Display',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'pointer',
          }}
        >
          {name}
        </InputLabel>
        {':'}
      </div>

      <FormControl variant="standard" sx={{ maxWidth: 300, }}>
        <Select
          multiple
          value={selectedKeys}
          renderValue={(selected) =>
            allOptions
              .filter((opt) => selected.includes(opt.key))
              .map((opt) => opt.label)
              .join(", ")
          }
          disableUnderline
          onChange={() => { }}
          sx={{
            pr: 4,
            '& .MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
            },
            '& .MuiSelect-root': {
              border: 'none'
            },
          }}
        >
          {Object.entries(parameters).map(([group, items]) => (
            <div key={group}>
              <MenuItem disabled>
                <strong>{group.charAt(0).toUpperCase() + group.slice(1)}</strong>
              </MenuItem>
              {items.map((item) => (
                <MenuItem
                  key={item.key}
                  value={item.key}
                  onClick={() => handleToggle(item.key)}
                >
                  <Checkbox
                    checked={selectedKeys.includes(item.key)}
                    sx={{
                      color: "#FFA737",
                      "&.Mui-checked": { color: "#FFA737" }
                    }}
                  />
                  <ListItemText primary={item.label} />
                </MenuItem>
              ))}
            </div>
          ))}

        </Select>
      </FormControl>
    </div >
  );
};

export default NestedDropdown;